import { createSelector } from 'reselect'
import { emptyObj } from 'util/objects'
import { removeKeysFromQueryId } from 'ducks/searches/utils/query'
import { selectCurrentQueryId } from 'ducks/searches/selectors'
import selectBase from './selectBase'

export const selectItemsById = createSelector(
  selectBase,
  base => base.itemsById
)

export const selectItems = createSelector(selectItemsById, itemsById =>
  Object.values(itemsById)
)

export function selectItemIdFromProps(_, props) {
  return props.itemId || null
}

export const selectCurrentFolderItemQueryId = createSelector(
  selectCurrentQueryId,
  currentQueryId => {
    return removeKeysFromQueryId(['orderBy'], currentQueryId)
  }
)

export const selectCurrentFolderItem = createSelector(
  selectItems,
  selectCurrentFolderItemQueryId,
  (folderItems, currentFolderItemQueryId) => {
    return (
      folderItems.find(fi => fi.queryId === currentFolderItemQueryId) ||
      emptyObj
    )
  }
)

export const selectCurrentFolderName = createSelector(
  selectCurrentFolderItem,
  folderItem => folderItem.name || null
)

export function makeSelectItemById() {
  return createSelector(
    selectItemsById,
    selectItemIdFromProps,
    (itemsById, itemId) => {
      return itemsById[itemId] || emptyObj
    }
  )
}
